import Modal from 'components/shared/modals/Modal'
import React from 'react'
import { ReactComponent as IconInfo } from 'images/info-circle-o.svg';
import styles from './NoInternetModal.module.scss'

type Props = {
  onClose: () => void
  isOpen: boolean
}

export function NoInternetModal({ isOpen, onClose }: Props) {
  return (
    <Modal
      onClose={onClose}
      isOpen={isOpen}
      className={styles.internetModal}
    >
      <IconInfo />
      <h3>Internet problems</h3>
      <span>Looks like you dont have internet</span>
    </Modal>
  )
}
